<template>
  <div class="picture-button">
    <we-rounded-picture
      :picture="picture"
      :direction="direction"
      :name="name"
      size="32"
    />
  </div>
</template>

<script>
export default {
  props: {
    direction: {
      default: "top",
      type: String
    },
    picture: String,
    name: String
  }
};
</script>

<style lang="scss">
.picture-button {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 18px;
  border-radius: 19px;
  cursor: pointer;

  &:hover {
    background: $dark8;
  }

  .picture {
    position: relative;
    height: 32px;
    width: 32px;
    border-radius: 32px;
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      top: 0;
      position: absolute;
      width: 100%;
      height: auto;
    }
  }
}
</style>
